module.exports = "/_next/static/images/stripe3-87e2a7fef61d209a452f43054b56ab03.png";